import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminReportingActions.js'

const initialState = {
  data: [],
  stats: [],
  requireRouteChange: false,
  filter: {}
}
const reporting = (state = initialState, action) => {
  switch (action.type) {
    case actions.REPORT_LOAD_DATA: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log(action.restCall.result)
        const d = {}
        const at = action.restCall.result.visibleTypes
        const sd = action.restCall.result.filter.startDate

        if (sd) {
          d.startDate = new Date(sd)
        }

        const ed = action.restCall.result.filter.endDate

        if (ed) {
          d.endDate = new Date(ed)
        }

        const loggedIn = action.restCall.result.filter.loggedIn

        if (loggedIn) {
          d.loggedIn = loggedIn
        }

        return {
          ...state,
          data: action.restCall.result.data,
          stats: action.restCall.result.stats,
          requireRouteChange: false,
          visibleTypes: at,
          filter: {
            kind: state.filter.kind,
            ...d
          }
        }
      }

      return state
    }

    case actions.UPDATE_FILTER_KIND: {
      console.log(action.kind)

      return {
        ...state,
        filter: {
          ...state.filter,
          kind: action.kind
        }
      }
    }

    case actions.UPDATE_REPORT_FIELD: {
      let requireRouteChange = state.requireRouteChange

      if (action.key === 'kind' && action.val !== state.filter.kind) {
        requireRouteChange = true
      }

      return {
        ...state,
        requireRouteChange,
        filter: {
          ...state.filter,
          [action.key]: action.val
        }
      }
    }

    default:
      return state
  }
}

export default reporting
